import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

type Props = {
  workloadConstraintsField: React.ReactNode;
  adornment?: React.ReactNode;
};

export const WorkloadConstraintsSettingsContainer = ({
  workloadConstraintsField,
  adornment,
}: Props) => {
  const { title, description, docsLinkKey } =
    vpaSettingsConstants.workloadConstraints;

  return (
    <VerticalSettingsForm
      title={title}
      description={description}
      docsLinkKey={docsLinkKey}
      titleAdornment={adornment}
    >
      {workloadConstraintsField}
    </VerticalSettingsForm>
  );
};
